import type { GridValueGetterParams } from '@mui/x-data-grid-pro'

import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'
import { conversionUtils } from '@/server-data'

export function useGetCommunicatedEtaRangeValue() {
  const userConfiguration = useSelector(selectUserConfiguration)

  return useCallback(
    (params: GridValueGetterParams) => {
      const fieldName = params.field.replace('formattedData.communicatedEtaRanges.', '')

      const timeWindow = params.row.communicatedEtaRanges[fieldName]

      if (!timeWindow) return '-'

      const { startSec, endSec } = timeWindow

      return `${conversionUtils.convertTime(userConfiguration)(
        startSec,
        false,
      )} - ${conversionUtils.convertTime(userConfiguration)(endSec, false)}`
    },
    [userConfiguration],
  )
}
